import type { ReactNode } from "react";

import { useTokens } from "../hooks/useTokens";
import { corDaBoia } from "../lib/cores";
import type { NodeState } from "../types";

interface Props {
  nos: NodeState[];
  /** A boia do painel. Está sempre ligada e não se desliga daqui. */
  principal: string;
  comparadas: string[];
  aoAlternar: (code: string) => void;
}

/**
 * Escolher que boias entram nos gráficos.
 *
 * O ponto colorido de cada ficha é a cor com que a boia é desenhada, e é a mesma
 * em todos os gráficos e em todas as sessões — a cor segue a boia, não a ordem
 * por que foi escolhida.
 *
 * A boia do painel não se desliga aqui: fechar o painel é que a tira. Um botão
 * que se desliga a si próprio deixava o ecrã sem dono.
 */
export function NodeChips({ nos, principal, comparadas, aoAlternar }: Props): ReactNode {
  const escuro = useTokens()["--modo"] === "dark";

  return (
    <div className="fichas" role="group" aria-label="Boias nos gráficos">
      {nos.map((no) => {
        const ehPrincipal = no.code === principal;
        const ligada = ehPrincipal || comparadas.includes(no.code);

        return (
          <button
            key={no.code}
            type="button"
            aria-pressed={ligada}
            disabled={ehPrincipal}
            title={ehPrincipal ? "Boia do painel — fecha o painel para a tirar" : no.name}
            onClick={() => aoAlternar(no.code)}
          >
            <i
              aria-hidden="true"
              style={{ background: ligada ? corDaBoia(no.code, escuro) : "transparent" }}
            />
            {no.code}
          </button>
        );
      })}
    </div>
  );
}
